import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { Key } from 'react';

const FEATURE_KEY = 'inventory';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface InventoryState {
  expandedKeys: Key[];
  selectedKey: string | undefined;
}

const initialState: InventoryState = {
  expandedKeys: [],
  selectedKey: undefined,
};

export const InventorySlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setExpandedKeys: (state, action: PayloadAction<Key[]>) => {
      state.expandedKeys = action.payload;
    },
    setSelectedKey: (state, action: PayloadAction<string>) => {
      state.selectedKey = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = InventorySlice.reducer;
const actions = InventorySlice.actions;

const state = (rootState: any): InventoryState => rootState[FEATURE_KEY];

const expandedKeysSelector = createSelector(
  state,
  (state) => state.expandedKeys
);

const selectedKeySelector = createSelector(state, (state) => state.selectedKey);

export {
  FEATURE_KEY,
  actions,
  expandedKeysSelector,
  reducer,
  selectedKeySelector,
};
